import React from 'react'
import { useEffect } from 'react'

const PageNotFound = () => {
  return (
    <div className='d-flex align-content-center justify-content-center' style={{height:"80vh"}}>
      <h1 className='d-flex m-auto'>Page Not Found 404 ERROR</h1>
    </div>
  )
}

export default PageNotFound